import { Data, Logger, Structure } from '@wix/thunderbolt-becky-types'
import { BeckyFunctionLibrary, BeckyModel } from '@wix/thunderbolt-becky-root'
import type { BeckyRequestPayload, AppWidgetGhostsBeckyModel } from '@wix/thunderbolt-becky-root'
import { createAppWidgetGhostFunctionLibrary } from './appWidgetGhostsFunctionLibrary'
import { flattenStructure } from '../../flattenStructure'
import _ from 'lodash'

const appWidgetGhostsModelFactory = require('./carmi/appWidgetsGhosts.carmi')

const runCarmiAsync = (model: AppWidgetGhostsBeckyModel, funcLib: BeckyFunctionLibrary) =>
	new Promise<{ structure: Structure; data: Data }>((done) =>
		appWidgetGhostsModelFactory(model, { ...funcLib, done })
	)

const resolveAppWidgetsGhosts = async (
	beckyModel: BeckyModel,
	masterPageStructure: Structure,
	masterPageData: Data,
	functionLibrary: BeckyFunctionLibrary,
	requestPayload: BeckyRequestPayload,
	logger: Logger
): Promise<{ structure: Structure; data: Data; masterPageStructure: Structure; masterPageData: Data }> =>
	functionLibrary.runAsyncAndReport(async () => {
		const resolveGhosts = requestPayload.resolveGhosts === 'true'
		const isMasterPage = beckyModel.pageCompId === 'masterPage'

		const structure = isMasterPage ? masterPageStructure : beckyModel.structure
		const data = isMasterPage ? masterPageData : beckyModel.data

		const hasAppWidgets = !_(structure)
			.values()
			.filter((comp) => !!comp.componentType && comp.componentType.endsWith('AppWidget'))
			.isEmpty()

		if (!resolveGhosts || !hasAppWidgets) {
			return {
				structure,
				data,
				masterPageStructure,
				masterPageData,
			}
		}

		const funcLib = {
			...functionLibrary,
			...createAppWidgetGhostFunctionLibrary(logger, beckyModel.metaSiteId),
			flattenStructure,
		}

		return runCarmiAsync(
			{
				...beckyModel,
				requestPayload,
				structure,
				data,
			},
			funcLib
		).then(({ structure: withGhostsStructure, data: withGhostsData }) => {
			if (isMasterPage) {
				return {
					structure: beckyModel.structure,
					data: beckyModel.data,
					masterPageStructure: withGhostsStructure,
					masterPageData: withGhostsData,
				}
			} else {
				return {
					structure: withGhostsStructure,
					data: withGhostsData,
					masterPageStructure,
					masterPageData,
				}
			}
		})
	}, 'tb-appWidgetsGhosts-resolving')

export { resolveAppWidgetsGhosts }
